import axios, { AxiosResponse } from "axios";
import UserService from "./UserService";
import SweepSecurityBase, { ClassesShow, SweepSecurityShow } from "../models/Security";

const API_BASE_URL = window._env_.REACT_APP_ARCOR_CENTRAL_API_URL;
const API_RESOURCE = "security/";

export default class SecurityService {
  public static async checkSweepSecurity(sweedIdx: number): Promise<boolean | null> {
    try {
      const response: AxiosResponse<boolean> = await axios.get(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/check_security",
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  public static async getSecuredSweeps(): Promise<SweepSecurityBase[] | null> {
    try {
      const response: AxiosResponse<SweepSecurityBase[]> = await axios.get(
        API_BASE_URL + API_RESOURCE,
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  public static async getSecuredSweep(sweedIdx: number): Promise<SweepSecurityShow | null> {
    try {
      const response: AxiosResponse<SweepSecurityShow> = await axios.get(
        API_BASE_URL + API_RESOURCE + sweedIdx,
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  public static async setDefaultSecurity(sweedIdx: number): Promise<string | null> {
    try {
      const response: AxiosResponse<string> = await axios.put(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/default",
        {},
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  public static async getSecurityClasses(sweedIdx: string) {
    try {
      const response = await axios.get(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/classes",
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async getSecurityClassesShow(sweedIdx: number): Promise<ClassesShow[] | null> {
    try {
      const response: AxiosResponse<ClassesShow[]> = await axios.get(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/classes",
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async setSecurityClasses(sweedIdx: number, classes: string[]): Promise<string | null> {
    try {
      const response: AxiosResponse<string> = await axios.post(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/create",
        classes,
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async uploadImage(sweedIdx: number, class_name: string, image: File): Promise<string | null> {
    try {
      const formData = new FormData();
        formData.append("class_name", class_name);
        formData.append("file", image);

      const response: AxiosResponse<string> = await axios.post(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/upload_image",
        formData,
        {
          headers: {...UserService.getAuthHeader(),
          "Content-Type": "multipart/form-data",}
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async cancelImage(sweedIdx: number): Promise<string | null> {
    try {
      const response: AxiosResponse<string> = await axios.post(
        API_BASE_URL + API_RESOURCE + sweedIdx + "/cancel",
        {},        
        {
          headers: UserService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}